import { Stack } from '@mantine/core';
import { useParams } from 'react-router-dom';

import {
  EditorPaneViewSelector, ResourceAssistantChat, ClearChatButton, type ViewSelectorProps
} from '../../../components';

type Props = ViewSelectorProps;

const AssistantView: React.FC<Props> = (props: Props) => {
  const { proposalUid, organization } = useParams();

  const clearChatButton = (
    <ClearChatButton
      organizationSlug={organization ?? ''}
      proposalUid={proposalUid}
    />
  );

  return (
    <Stack gap={0} flex={1}>
      <EditorPaneViewSelector {...props} rightSection={clearChatButton} />
      <ResourceAssistantChat
        style={{ flex: 1, minHeight: 0 }}
      />
    </Stack>
  );
};

export default AssistantView;
